var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('Transition',[(_vm.area=='')?_c('AreasDePractica',{attrs:{"lang":_vm.lang}}):_c('AreaDePractica',{attrs:{"area":_vm.area,"lang":_vm.lang}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }